import React from "react";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";

const WebinarPricingInfo = ({
  pricingInfo,
  showPricingTitle = false,
  pricingTitle,
  showOriginalPrice = true,
  showDiscountBadge = true,
  containerClassName = "",
  subtitleClassName = "",
  priceClassName = "",
  originalPriceClassName = "",
}) => {
  const { t } = useTranslation();

  if (!pricingInfo) return null;

  return (
    <div className={containerClassName}>
      {showPricingTitle && (
        <span className={subtitleClassName || "text-sm text-slate-500"}>
          {t(pricingTitle || "Subtotal")}
        </span>
      )}
      <div className="flex items-center gap-2 flex-wrap">
        <NumericFormat
          displayType="text"
          value={pricingInfo.displayPrice}
          thousandSeparator="."
          decimalSeparator=","
          prefix="Rp"
          className={priceClassName || "text-base font-bold text-slate-900"}
        />
        {showOriginalPrice && pricingInfo.displayOriginalPrice && (
          <NumericFormat
            displayType="text"
            value={pricingInfo.displayOriginalPrice}
            thousandSeparator="."
            decimalSeparator=","
            prefix="Rp"
            className={
              originalPriceClassName ||
              "text-base font-normal text-slate-400 line-through"
            }
          />
        )}
        {showDiscountBadge && pricingInfo.discountPercentage > 0 && (
          <span className="inline-flex items-center px-1.5 rounded text-xs font-bold text-red-600 bg-red-50 leading-5">
            -{pricingInfo.discountPercentage}%
          </span>
        )}
      </div>
    </div>
  );
};

export { WebinarPricingInfo };
